export default __webpack_public_path__ + "static/media/Quicksilver.59c9d73b.jpg";